import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import MessageContent, { StyledMessageContent } from "../MessageContent";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import NewMessageButtons from "./NewMessageButtons";

import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";

import { Dropdown } from "primereact/dropdown";

interface NewMessageContentProps {}

const NewMessageContent: React.FC<NewMessageContentProps> =
  withWSErrorContainer(
    observer(({}) => {
      const [value1, setValue1] = useState("");
      const [value2, setValue2] = useState("");
      const [selectedContact, setSelectedContact] = useState<any>(null);

      const userInfo = useContext(UserInfoContext);

      const onSelectChange = (e: { value: any }) => {
        setSelectedContact(e.value);
      };

      return (
        <StyledMessageContent className="cpv-message-content flex-grow-1">
          <StyledMsgInputContainer className="cvp-message-input-container">
            <label htmlFor="username1" className="block">
              Fra:
            </label>
            <div>Navn Navnesen</div>
            <label htmlFor="username1" className="block">
              Til:
            </label>
            <Dropdown
              value={selectedContact}
              options={contacts}
              onChange={onSelectChange}
            />
            <label htmlFor="username1" className="">
              Emne:
            </label>
            <InputText
              value={value1}
              onChange={(e) => setValue1(e.target.value)}
              id="emne"
              aria-describedby="emne-help"
              className=""
            />
            <label></label>

            <InputTextarea
              rows={8}
              className="mt-5 cvp-text-area"
              value={value2}
              onChange={(e) => setValue2(e.target.value)}
              autoResize
            />
          </StyledMsgInputContainer>

          <div className="flex justify-content-end mt-5">
            <NewMessageButtons />
          </div>
        </StyledMessageContent>
      );
    })
  );
export default NewMessageContent;

export const StyledMsgInputContainer = styled.div`
  &.cvp-message-input-container {
    display: grid;
    grid-template-columns: fit-content(1000px) auto;
    grid-auto-flow: row;
    grid-template-rows: auto auto;
    grid-auto-rows: auto;
    grid-gap: 1rem;
    align-items: center;

    & label {
      font-weight: 700;
    }

    .cvp-text-area {
      height: 100%;
      display: flex;
      align-self: stretch;
    }

    @media ${device} {
    }
  }
`;

const contacts = [
  { label: "Name 1" },
  { label: "Name 2" },
  { label: "Name 3" },
  { label: "Name 4" },
  { label: "Name 5" },
];
